/* AUTOGENERATED FILE - OVERRIDDEN FOR LOCAL TESTING */

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "http://127.0.0.1:54331";
export const publicAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0";

// Dynamically extract project ID from supabase URL, or default to "local"
export const projectId = supabaseUrl.includes('supabase.co') 
  ? supabaseUrl.split('//')[1].split('.')[0] 
  : "local";